import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useTenant } from "../../../Contexts/TenantContext";
import { productService } from "../../../Api/Services/productService";
import { orderService } from "../../../Api/Services/orderService";
import { customerService } from "../../../Api/Services/customerService";
import { whatsAppService } from "../../../Api/Services/whatsAppService";
import { formatCnpj } from "../../../Utils/DataFormatters";
import { toast } from "react-toastify";
import SmartNavbar from "../../../Components/SmartNavbar/SmartNavbar";
import AdminNotificationPanel from "../../../Components/AdminNotificationPanel/AdminNotificationPanel";
import Button from "../../../Components/Button/Button";

const AdminHomePage = () => {
  const { tenant, tenantContact } = useTenant();

  const navigate = useNavigate();

  const [productCount, setProductCount] = useState(0);
  const [orderCount, setOrderCount] = useState(0);
  const [customerCount, setCustomerCount] = useState(0);
  const [messageCount, setMessageCount] = useState(0);

  const getProductCount = useCallback(async () => {
    try {
      const count = await productService.getCount();
      setProductCount(count);
    } catch (error) {
      toast.error("Erro ao buscar número de produtos.");
    }
  }, []);

  const getOrderCount = useCallback(async () => {
    try {
      const count = await orderService.getCount();
      setOrderCount(count);
    } catch (error) {
      toast.error("Erro ao buscar número de pedidos.");
    }
  }, []);

  const getCustomerCount = useCallback(async () => {
    try {
      const count = await customerService.getCount();
      setCustomerCount(count);
    } catch (error) {
      toast.error("Erro ao buscar número de clientes.");
    }
  }, []);

  const getMessageCount = useCallback(async () => {
    try {
      const count = await whatsAppService.getMessageCount();
      setMessageCount(count);
    } catch (error) {
      toast.error("Erro ao buscar número de mensagens.");
    }
  }, []);

  useEffect(() => {
    void getProductCount();
    void getOrderCount();
    void getCustomerCount();
    void getMessageCount();
  }, [getProductCount, getCustomerCount, getMessageCount, getOrderCount]);

  return (
    <div>
      <SmartNavbar />
      <main className={`max-w-6xl mx-auto py-10 px-6`}>
        <h1 className="text-2xl font-bold mb-4">{"Bem-vindo!"}</h1>

        <section className={`mb-6 p-4 border shadow-sm bg-white rounded`}>
          <h2 className="text-lg font-semibold mb-2">{"Informações da Empresa:"}</h2>
          <ul className="text-sm text-gray-700">
            <li><strong>{"Nome"}:</strong> {tenant.companyName}</li>
            {tenant.cnpj && (
              <li><strong>CNPJ:</strong> {formatCnpj(tenant.cnpj)}</li>
            )}
            <li><strong>Email:</strong> {tenantContact.email}</li>
          </ul>
        </section>

        {/* Mobile: 2-column combined cards */}
        <section className="grid grid-cols-2 gap-4 sm:hidden">
          {[
            { count: productCount, label: "Produtos", btnLabel: "Ver Produtos", path: "/admin/produtos" },
            { count: orderCount, label: "Pedidos", btnLabel: "Ver Pedidos", path: "/admin/pedidos" },
            { count: customerCount, label: "Clientes", btnLabel: "Gerenciar clientes", path: "/admin/clientes" },
            { count: messageCount, label: "Mensagens WhatsApp", btnLabel: "Ver WhatsApp", path: "/admin/whatsapp" },
          ].map(({ count, label, btnLabel, path }) => (
            <div key={label} className="border bg-white shadow-sm rounded overflow-hidden flex flex-col">
              <div className="p-3 text-center flex-1 flex flex-col items-center justify-center">
                <h3 className="text-xl font-bold">{count}</h3>
                <p className="text-sm text-gray-600">{label}</p>
              </div>
              <Button
                onClick={() => navigate(path)}
                className="w-full py-3 text-sm !rounded-none"
              >
                {btnLabel}
              </Button>
            </div>
          ))}
        </section>

        {/* Desktop: stat row + button row */}
        <section className="hidden sm:grid sm:grid-cols-4 gap-4">
          <div className="p-4 border bg-white shadow-sm text-center rounded">
            <h3 className="text-xl font-bold">{productCount}</h3>
            <p className="text-sm text-gray-600">{"Produtos"}</p>
          </div>
          <div className="p-4 border bg-white shadow-sm text-center rounded">
            <h3 className="text-xl font-bold">{orderCount}</h3>
            <p className="text-sm text-gray-600">{"Pedidos"}</p>
          </div>
          <div className="p-4 border bg-white shadow-sm text-center rounded">
            <h3 className="text-xl font-bold">{customerCount}</h3>
            <p className="text-sm text-gray-600">{"Clientes"}</p>
          </div>
          <div className="p-4 border bg-white shadow-sm text-center rounded">
            <h3 className="text-xl font-bold">{messageCount}</h3>
            <p className="text-sm text-gray-600">{"Mensagens WhatsApp"}</p>
          </div>
          <Button
            onClick={() => navigate("/admin/produtos")}
            className="w-full py-4"
          >
            {"Ver Produtos"}
          </Button>
          <Button
            onClick={() => navigate("/admin/pedidos")}
            className="w-full py-4"
          >
            {"Ver Pedidos"}
          </Button>
          <Button
            onClick={() => navigate("/admin/clientes")}
            className="w-full py-4"
          >
            {"Gerenciar clientes"}
          </Button>
          <Button
            onClick={() => navigate("/admin/whatsapp")}
            className="w-full py-4"
          >
            {"Ver WhatsApp"}
          </Button>
        </section>

        <AdminNotificationPanel />
      </main>
    </div>
  );
};

export default AdminHomePage;
